import { render, staticRenderFns } from "./DataMapper.vue?vue&type=template&id=10286aad&scoped=true"
import script from "./DataMapper.vue?vue&type=script&lang=js"
export * from "./DataMapper.vue?vue&type=script&lang=js"
import style0 from "./DataMapper.vue?vue&type=style&index=0&id=10286aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10286aad",
  null
  
)

export default component.exports